export default "__VITE_ASSET__FGNCju____"